export const SCHEDULED_ORDER_IDS = {
  date: 'date',
  time: 'time',
  confirm: 'confirm',
  back: 'back'
};
